import { getSheet } from './tilesets'

// Shared tile-cell drawing logic, used by both the live game canvas
// (components/canvas.js) and the editor board so they render identically.

const loadImage = (cache, src) => {
  if (cache[src] instanceof Image) return cache[src]
  if (cache[src]) return null // 'loading' or 'error'
  cache[src] = 'loading'
  const img = new Image()
  img.src = src
  img.onload = () => { cache[src] = img }
  img.onerror = () => { cache[src] = 'error' }
  return null
}

export const loadSheet = (cache, sheetId) => {
  const sheet = getSheet(sheetId)
  if (!sheet) return null
  return loadImage(cache, sheet.src)
}

// Draws one tile cell into the rect (dx,dy,dw,dh). `tile` is a TileCell:
//   { tileset, tx, ty, solid, opacity?, flipX? }  — 48px slice from a registered sheet
//   { bgColor, solid, opacity? }                  — flat color fill
export const drawTileCellRect = (ctx, tile, dx, dy, dw, dh, imageCache) => {
  if (!tile) return false

  if (tile.tileset && tile.tx != null && tile.ty != null) {
    const sheet = getSheet(tile.tileset)
    const img = loadSheet(imageCache, tile.tileset)
    if (img instanceof Image && sheet) {
      const ts = sheet.tileSize
      if (tile.flipX) {
        ctx.save()
        ctx.translate(dx + dw, dy)
        ctx.scale(-1, 1)
        ctx.drawImage(img, tile.tx * ts, tile.ty * ts, ts, ts, 0, 0, dw, dh)
        ctx.restore()
      } else {
        ctx.drawImage(img, tile.tx * ts, tile.ty * ts, ts, ts, dx, dy, dw, dh)
      }
      return true
    }
    // Placeholder while the sheet image loads
    ctx.fillStyle = '#554433'
    ctx.fillRect(dx, dy, dw, dh)
    return true
  }

  if (tile.bgColor) {
    ctx.fillStyle = tile.bgColor
    ctx.fillRect(dx, dy, dw, dh)
    return true
  }

  return false
}
